import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef } from "react";
import {
  Wallet,
  setWithdrawDialog,
} from "../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { HiOutlineBanknotes, HiOutlineMinusCircle } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const WithdrawForm = (props) => {
  const dispatch = useDispatch();
  const _Wallet = useSelector((state) => state.wallet);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody
  );
  const { control, handleSubmit } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.from_user_id = props.userData.id;
    dispatch(Wallet.withdraw(data, transactionsSearchBody)).then((x) => {
      dispatch(setWithdrawDialog());
    });
  };

  const handlDialog = () => {
    dispatch(setWithdrawDialog());
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <FormDialog
      open={_Wallet.withdrawDialog}
      onClose={handlDialog}
      icon={<HiOutlineMinusCircle />}
      title={"سحب رصيد من المندوب"}
      subtitle="أدخل المبلغ الكلي والمبلغ المرجوع ثم احفظ"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="المبالغ">
        <Grid item xs={12} sm={6}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ الكلي"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="cash_back"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ المرجوع"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default WithdrawForm;
